import clsx from "clsx";
import { ComponentPropsWithoutRef, ReactElement } from "react";

export const SidebarLabel = ({
  className,
  ...props
}: ComponentPropsWithoutRef<"span">): ReactElement => (
  <span {...props} className={clsx(className, "truncate")} />
);
